import { useAppSelector } from 'store/store';
import { BottomFromTechnicianCoordinatorRoles } from 'shared/permissions/roles';

export function IsBottomFromTechnicianCoordinator({ children }) {
  const groups = useAppSelector((state) => state.auth.groups);
  if (groups?.some((role) => BottomFromTechnicianCoordinatorRoles.includes(role))) return children;
}

export function useIsBottomFromTechnicianCoordinator(): boolean {
  const groups = useAppSelector((state) => state.auth.groups);
  return groups?.some((role) => BottomFromTechnicianCoordinatorRoles.includes(role)) ?? false;
}
